import { queryOptions, useQuery } from '@tanstack/react-query';

import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

import { overrideOrganizationHeader } from '@cast/api-client';

import { filterHiddenPlatformUsageFeatures } from '../../../utils/billing/filterHiddenPlatformUsageFeatures';

const ENTERPRISE_PLATFORM_USAGE_REPORT_QUERY_KEY =
  'enterprise-platform-usage-report';
const getEnterprisePlatformUsageReportQueryKey = (params: {
  enterpriseId: string | undefined;
}) =>
  [ENTERPRISE_PLATFORM_USAGE_REPORT_QUERY_KEY, params.enterpriseId] as const;

const getEnterprisePlatformUsageReportQueryOptions = ({
  enterpriseId,
  enabled = true,
}: {
  enterpriseId: string | undefined;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getEnterprisePlatformUsageReportQueryKey({ enterpriseId }),
    queryFn: async () => {
      const { data } = await apiClient.billing.getEnterprisePlatformUsageReport(
        {
          headers: overrideOrganizationHeader(enterpriseId),
        }
      );
      return filterHiddenPlatformUsageFeatures(data);
    },
    enabled: makeIsEnabled(!!enterpriseId, enabled),
  });

export const useEnterprisePlatformUsageReportQuery = ({
  enterpriseId,
  enabled = true,
}: {
  enterpriseId: string | undefined;
  enabled?: boolean;
}) => {
  const { isLoading, isError, data, error } = useQuery(
    getEnterprisePlatformUsageReportQueryOptions({
      enterpriseId,
      enabled,
    })
  );

  return { isLoading, isError, data, error };
};
